<template>
  <div v-if="getPermission.fsi.view || getPermission.acnit.view">

      <md-tabs md-sync-route class="FSIDailyreport-tabs">
        <md-tab id="tab-inbound" md-label="Inbound Report" to="/FSIDailyreport/FSIDailyreportInbound" v-if="getPermission.fsi.view || getPermission.acnit.view"></md-tab>
        <md-tab id="tab-no-show" md-label="No show Report" to="/FSIDailyreport/FSIDailyreportNoshow" v-if="getPermission.fsi.view || getPermission.acnit.view"></md-tab>
        <md-tab id="tab-detention" md-label="Detention Report" to="/FSIDailyreport/FSIDailyreportDetention" v-if="getPermission.fsi.view || getPermission.acnit.view"></md-tab>
        <md-tab id="tab-progress" md-label="Daily Progress Report" to="/FSIDailyreport/FSIDailyreportProgress" v-if="getPermission.fsi.view || getPermission.acnit.view"></md-tab>
      </md-tabs>
      <router-view/>

  </div>

</template>

<style lang="scss">


.FSIDailyreport-tabs {
  .md-tabs-navigation {
    .md-theme-default {
      height: 30px;
    }
  }
}
</style>


<script>
import { mapGetters } from 'vuex';
export default {
  data: () => ({}),
  computed: {
    ...mapGetters([
      'getPermission',
      'getMasterDataName',
    ]),
  },
};
</script>
